export {default} from './EarningsSection.connect';
